import {
	genericProps,
	customColors,
	fiftyPercentLine,
	emptyDataObj,
	barLabelProps,
  } from "../config/chart-config-v2";
   
  export function getInitialRoundObj() {
	const initialRound = {
	  name: "r0",
	  ...genericProps,
	  markLine: fiftyPercentLine,
	  data: [
		{
		  value: 65,
		  itemStyle: {
			color: customColors[0],
			opacity: 1,			
		  },
		  label: {
			show: false,
		  },
		},
		{
		  value: 1,
		  itemStyle: {
			color: customColors[1],
			opacity: 1,	
			borderWidth:0,
			
		  },
		  label: {
			show: false,
		  },
		},
		{
		  value: 1,
		  itemStyle: {
			color: customColors[2],
			opacity: 1,
		  },
		  label: {
			show: false,
		  },
		},
		{
		  value: 1,
		  itemStyle: {
			color: customColors[3],
			opacity: 1,
		  },
		  label: {
			show: false,
		  },
		},
		{
		  value: 1,
		  itemStyle: {
			color: customColors[4],
			opacity: 1,
		  },
		  label: {
			show: false,
		  },
		},
		{
		  value: 1,
		  itemStyle: {
			color: customColors[5],
			opacity: 1,
		  },
		  label: {
			show: false,
		  },
		},
		{
		  value: 1,
		  itemStyle: {
			color: customColors[6],
			opacity: 1,
		  },
		  label: {
			show: false,
		  },
		},
	  ],
	};
	return initialRound;
  }

  
   
  export function getAppConfig() {
	const round0 = getInitialRoundObj();
	const appData = [
	  round0,
	  {
		name: "r1",
		...genericProps,
		markLine: fiftyPercentLine,
		animationDelay: null,
		animationDelayUpdate: null,
		data: [
		  emptyDataObj,
		  {
			value: 25, //25
			itemStyle: {
			  color: customColors[1],
			  label:{
				  show:true
			  }
			  
			},
			
			...barLabelProps,
		  },
		  {
			value: 15, //15
			itemStyle: {
			  color: customColors[2],
			},
			...barLabelProps,
		  },
		  {
			value: 10, //10
			itemStyle: {
			  color: customColors[3],
			},
			...barLabelProps,
		  },
		  {
			value: 5, //5
			itemStyle: {
			  color: customColors[4],
			},
			...barLabelProps,
		  },
		  {
			value: 30, //30
			itemStyle: {
			  color: customColors[5],
			},
			...barLabelProps,
		  },
		  {
			value: 15, //15
			itemStyle: {
			  color: customColors[6],
			},
			...barLabelProps,
		  },
		],
	  },
	  {
		name: "r2",
		...genericProps,
		data: [
		  emptyDataObj,
		  {
			value: 2,
			itemStyle: {
			  color: customColors[4],
			},
			...barLabelProps,
			
		  },
		  {
			value: 1,
			itemStyle: {
			  color: customColors[4],
			},
			...barLabelProps,
		  },
		  {
			value: 0,
			label:{
				show:true
			},
			...barLabelProps,
		  },
		  {
			value: 0,
			label:{
				show:true
			},
			...barLabelProps,
		  },
		  {
			value: 2,
			itemStyle: {
			  color: customColors[4],
			},
			...barLabelProps,
		  },
		  {
			value: 0,
			label:{
				show:true
			},
			...barLabelProps,
		  },
		],
	  },
	  {
		name: "r3",
		...genericProps,
		data: [
		  emptyDataObj,
		  {
			value: 5,
			itemStyle: {
			  color: customColors[3],
			},
			...barLabelProps,
		  },
		  {
			value: 1,
			itemStyle: {
			  color: customColors[3],
			},
			...barLabelProps,
		  },
		  {
			value: 0,
			label:{
				show:true
			},
			...barLabelProps,
		  },
		  {
			value: 0,
			label:{
				show:true
			},
			...barLabelProps,
		  },
		  {
			value: 3,
			itemStyle: {
			  color: customColors[3],
			},
			...barLabelProps,
		  },
		  {
			value: 1,
			itemStyle: {
			  color: customColors[3],
			},
			...barLabelProps,
		  },
		],
	  },
	  {
		name: "r4",
		...genericProps,
		data: [
		  emptyDataObj,
		  {
			value: 14,
			itemStyle: {
			  color: customColors[6],
			},
			...barLabelProps,
		  },
		  {
			value: 0,
			label:{
				show:true
			},
			...barLabelProps,
		  },
		  {
			value: 0,
			label:{
				show:true
			},
			...barLabelProps,
		  },
		  {
			value: 0,
			label:{
				show:true
			},
			...barLabelProps,
		  },
		  {
			value: 2,
			itemStyle: {
			  color: customColors[6],
			},
			...barLabelProps,
		  },
		  {
			value: 0,
			label:{
				show:true
			},
			...barLabelProps,
		  },
		],
	  },
	  {
		name: "r5",
		...genericProps,
		data: [
		  emptyDataObj,
		  {
			value: 6,
			itemStyle: {
			  color: customColors[2],
			},
			...barLabelProps,
		  },
		  {
			value: 0,
			label:{
				show:true
			},
			...barLabelProps,
		  },
		  {
			value: 0,
			label:{
				show:true
			},
			...barLabelProps,
		  },
		  {
			value: 0,
			label:{
				show:true
			},
			...barLabelProps,
		  },
		  {
			value: 11,
			itemStyle: {
			  color: customColors[2],
			},
			...barLabelProps,
		  },
		  {
			value: 0,
			label:{
				show:true
			},
			...barLabelProps,
		  },
		],
	  },
	   {
		name: "r6",
		...genericProps,
		markLine: fiftyPercentLine,
		hasVotingEnded: true,
		animation:false,
		data: [
		  emptyDataObj,
		  {
			value: 52,
			itemStyle: {
			  color: customColors[2],
			},
			...barLabelProps,
		  },
		  {
			value: 17,
			itemStyle: {
				color: customColors[2],
			  },
			label:{
				show:true
			},
			...barLabelProps,
		  },
		  {
			value: 10,
			itemStyle: {
				color: customColors[3],
			  },
			label:{
				show:true
			},
			...barLabelProps,
		  },
		  {
			value: 5,
			itemStyle: {
				color: customColors[4],
			  },
			label:{
				show:true
			},
			...barLabelProps,
		  },
		  {
			value: 48,
			itemStyle: {
			  color: customColors[5],
			},
			...barLabelProps,
		  },
		  {
			value: 16,
			itemStyle: {
				color: customColors[6],
			  },
			label:{
				show:true
			},
			...barLabelProps,
		  },
		],
	  },
	];
	return appData;
  }
   
  
  


// WEBPACK FOOTER //
// ./src/config/app-config.js